import { Assessment } from './assessment';
import { ActiveClassroom, ClassroomStudent, Position } from './classroom';
import { ProblemDetails } from './error';
import { ActiveSimulation } from './simulation';

export enum SimulationEventMessage {
  AssessmentUpdated = 'assessmentUpdated',
  ClassroomError = 'classroomError',
  ClassroomPositions = 'classroomPositions',
  ClassroomUpdated = 'classroomUpdated',
  ClassroomUsers = 'classroomUsers',
  ParticipantSimulationStarted = 'participantSimulationStarted',
  ParticipantSimulationCompleted = 'participantSimulationCompleted',
  SimulationCompleted = 'simulationCompleted',
  SimulationUpdated = 'simulationUpdated',
}

export type SessionCompletedStatuses = SessionSuccessStatuses | SessionErrorStatuses;

export enum SessionSuccessStatuses {
  Completed = 'Completed',
  Ongoing = 'Ongoing',
}

export enum SessionErrorStatuses {
  AbandonedByUser = 'AbandonedByUser',
  ClientFailed = 'ClientFailed',
  Failed = 'Failed',
  LicenseRevoked = 'LicenseRevoked',
}

export type SimulationUpdatedNotification = ActiveSimulation;

export interface ParticipantNotification {
  simulationId: string;
  status: SessionCompletedStatuses;
  userIds: string[];
}

export interface SimulationCompletedNotification {
  message: string | null;
  simulationId: string;
  status: SessionCompletedStatuses;
}

export interface AssessmentUpdatedNotification {
  assessments: Assessment[];
  exerciseId: string;
  simulationId: string;
  status: SessionSuccessStatuses;
  userId: string;
}

export enum SimulationSignal {
  Abandon = 'abandon',
  Pause = 'pause',
  Play = 'play',
  Stop = 'stop',
}

export type SimulationSignalType =
  | SimulationSignal.Abandon
  | SimulationSignal.Pause
  | SimulationSignal.Play
  | SimulationSignal.Stop;

export type ClassroomUpdatedNotification = ActiveClassroom;
export type ClassroomPositionsNotification = Position[];
export type ClassroomUsersNotification = ClassroomStudent[];

export interface SimulationHub {
  classroomUpdated(notification: ClassroomUpdatedNotification): void;
  simulationUpdated(notification: SimulationUpdatedNotification): void;
  simulationCompleted(notification: SimulationCompletedNotification): void;
  classroomError(error: ProblemDetails): void;
  assessmentUpdated(notification: AssessmentUpdatedNotification): void;
  participantSimulationStarted(notification: ParticipantNotification): void;
  participantSimulationCompleted(notification: ParticipantNotification): void;
  classroomPositions(exerciseId: string, notification: ClassroomPositionsNotification): void;
  classroomUsers(exerciseId: string, notification: ClassroomUsersNotification): void;
}
